import { render, staticRenderFns } from "./SanNong.vue?vue&type=template&id=10b1979e&scoped=true&"
import script from "./SanNong.vue?vue&type=script&lang=js&"
export * from "./SanNong.vue?vue&type=script&lang=js&"
import style0 from "./SanNong.vue?vue&type=style&index=0&id=10b1979e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b1979e",
  null
  
)

export default component.exports